import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import ManagmentGrid from "./ManagmentGrid";



export default function ManagmentMenu({onClose}:{onClose: () => void}) {
  const { t, i18n } = useTranslation();

  return (
      <>
        <div className="flex flex-col">
          <div className="flex flex-row h-14 items-center px-6">
            <NavLink to={"/managment"} onClick={onClose}><div className="text-base font-semibold flex h-14 items-center">{t("managment")}</div></NavLink>
          </div>
        </div>
        <div className="px-6 pt-3">
          <ManagmentGrid onClose={onClose}/>
        </div>
      </>
  )
} 